<template>
  <template
    v-if="cItem.show === undefined || cItem.show"
  >
    <template v-if="cItem.type === 'divider'">
      <td colspan="2" style="background-color:#DCE6F0" class="py-2" />
    </template>
    <InputRulesWrapper
      v-else
      :id="'sid_'+cItem.value"
      v-slot="{ attrs }"
      :rules="cItem?.rules"
      :props="{ label: cItem?.label }"
      :name="cItem?.value"
      class="LetsAtFormElement"
      :class="wrapperClass"
      tag="tr"
      :model-value="modelValue||undefined"
    >
      <!-- Input -->
      <td v-debug>
        {{ modelValue }}
      </td>
      <td
        v-if="cItem.label !== undefined"
        v-bind="{...labelAttrs, ...cItem.labelProps}"
        class="itemLabel"
        :class="{
          required: cItem?.rules?.includes('required')
        }"
      >
        <slot name="label-prepend" />
        <span v-html="cItem.label" />
        <slot name="label-append" />
      </td>
      <td class="itemInput" v-bind="cItem.itemInputTdProps">
        <div class="itemInputDiv" v-bind="cItem.itemInputDivProps">
          <!-- html -->
          <div v-if="cItem.type === 'html'" class="d-flex">
            <span v-if="cItem?.prefix" class="pr-2">{{cItem.prefix}}</span>
            <div v-html="props.modelValue?.replace(/\n/g,'<br />')" />
          </div>
          <!-- radio button -->
          <VRadioGroup
            v-else-if="cItem.type === 'radio'"
            v-bind="{...cItem.props}"
            :model-value="props.modelValue"
            inline
            color="primary"
            hide-details="auto"
            @update:model-value="($event) => $emit('update:modelValue', $event)"
          >
            <VRadio
              v-for="option in cItem.options"
              :key="cItem.label+'_' + option.value"
              :label="option.label"
              :value="option.value"
            />
          </VRadioGroup>
          <!-- mutiselect checkbox -->
          <AtCheckbox
            v-else-if="cItem.type === 'checkbox'"
            v-bind="{...cItem.props}"
            :items="cItem.options"
            item-title="label"
            item-value="value"
            :items-per-row="5"
            :model-value="props.modelValue"
            @update:model-value="($event) => $emit('update:modelValue', $event)"
          />
          <!-- Variable -->
          <VariableTextField
            v-else-if="cItem.type === 'variable'"
            v-bind="{...cItem.props}"
            :model-value="props.modelValue"
            :label="cItem.label"
            variant="outlined"
            density="compact"
            hide-details="auto"
            @update:model-value="($event) => $emit('update:modelValue', $event)"
            @update:search-input="($event) => $emit('update:search-input', $event)"
          />
          <Component
            :is="cItem.component|| 'VTextField'"
            v-else
            :model-value="props.modelValue"
            v-bind="{
              ...attrs,
              label: '',
              variant: 'outlined',
              density: 'compact',
              'hide-details': 'auto',
              ...cItem.props
            }"
            v-on="{
              ...cItem.listeners,
            }"
            @update:model-value="($event) => $emit('update:modelValue', $event)"
            @update:search-input="($event) => $emit('update:search-input', $event)"
          />
        </div>
      </td>
      <td v-debug>
        {{
          cItem
        }}
      </td>
    </InputRulesWrapper>
  </template>
</template>

<script setup>
import { defineAsyncComponent, computed, useAttrs } from 'vue';
import { AtFormUtils, PresetList } from '../base/atoms/AtForm/AtFormUtils';
import AtCheckbox from '../base/atoms/input/AtCheckBox/AtCheckbox.vue';
import ObjArrUtils from '@/utils/ObjArrUtils';

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  modelValue: {
    type: null,
    default: null
  },
  labelAttrs: {
    type: Object,
    required: false,
    default: () => ({})
  },
  wrapperClass: {
    type: [String, Object, Array],
    default: undefined
  }
});

const emit = defineEmits(['update:modelValue', 'update:search-input']);

import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const cItem = computed(() => {
  // Pass translation function as ctx.$t for PresetList compatibility
  const ctx = { $t: t };
  return ObjArrUtils.merge(
    {
      type: null,
      rules: [],
      props: {},
      labelProps: {},
      itemInputTdProps: {},
      itemInputDivProps: {},
      listeners: {}
    },
    PresetList(ctx)[props.item.type] || {},
    props.item,
  );
});

const VariableTextField = defineAsyncComponent(() => import('@/components/base/atoms/VariableTextField/VariableTextField.vue'));
</script>

<style scoped>

</style>
